function distinctObjects (array, key) {
  const distinctArray = array.reduce((acc, current) => {
    const x = acc.find(item => item[key] === current[key])
    if (!x) {
      return acc.concat([current])
    } else {
      return acc
    }
  }, [])

  return distinctArray
}

export default distinctObjects



// WEBPACK FOOTER //
// ./src/utility/distinctObjects.js